// Tipos compartilhados do módulo Operacional → Contratos.
// Extraído de OperacionalContratos.tsx no refactor de 2026-05-23.

export interface Contrato {
  id: string;
  negocio_id: number;
  numero: string;
  titulo: string;
  cliente_id: number;
  cliente_nome?: string;
  cliente_cnpj?: string;
  cliente_endereco?: string;
  cliente_bairro?: string;
  cliente_cidade?: string;
  cliente_uf?: string;
  cliente_cep?: string;
  contato_principal_id?: number;
  contato_nome?: string;
  contato_email?: string;
  contato_telefone?: string;
  responsavel_email?: string;
  gestor_email?: string;
  coordenador_email?: string;
  data_inicio_prevista?: string;
  data_termino_previsto?: string;
  data_inicio_real?: string;
  data_termino_real?: string;
  status: string;
  valor_contratado?: number;
  forma_pagamento?: string;
  // Áreas e CNAE (2026-10-04): divisão padrão das parcelas novas e o código de
  // serviço da nota do contrato (quem mostra e edita é o cartão "Áreas e CNAE").
  rateio_setores_default?: Record<string, number> | null;
  rateio_setores_origem?: string | null;
  cnae?: string | null;
  cnae_manual?: boolean;
  art_numero?: string;
  art_data_emissao?: string;
  observacoes?: string;
  cliente_link_hash?: string | null;
  negocio_titulo?: string;
  atividades_total?: number;
  atividades_concluidas?: number;
  atividades_abertas?: number;
  docs_total?: number;
  criado_em: string;
  // Onda Op-2 — hierarquia (aditivo)
  contrato_pai_id?: string | null;
  ordem?: number;
  motivo_aditivo?: string;
  // 2026-08-21: vêm do op_obter_contrato pra montar o caminho de volta ao pai.
  // A lista de contratos esconde aditivos (contrato_pai_id IS NULL), então sem
  // isto quem abre um aditivo não tem como voltar pro contrato de onde veio.
  pai_numero?: string | null;
  pai_titulo?: string | null;
  aditivos_total?: number;
  aditivos_valor_soma?: number;
  aditivos?: Array<{
    id: string; numero: string; titulo: string; valor_contratado: number;
    motivo_aditivo: string | null; data_inicio_prevista: string | null;
    data_termino_previsto: string | null; status: string; ordem: number; criado_em: string;
  }>;
  valor_total_com_aditivos?: number;
  arts_total?: number;
  parcelas_abertas?: number;
  parcelas_valor_aberto?: number;
  arts?: ArtFull[];
  parcelas?: Array<{
    id: string; numero_parcela: number | null; descricao: string | null;
    parcela_titulo?: string | null;
    contrato_numero?: string | null;  // backend retorna o numero do dono real (sub-OS)
    eh_sub_os?: boolean;              // true se vem de filho (não do contrato direto)
    cliente_id?: number | null;       // pagador da parcela (multi-CNPJ, 2026-07-07)
    valor_previsto: number; valor_recebido: number | null;
    data_vencimento: string; data_recebimento: string | null;
    status: string; nota_fiscal_numero: string | null;
    nota_fiscal_emissao?: string | null;
    prazo_dias?: number | null;
    meio_pagamento?: string | null;
    tipo_parcela?: 'mobilizacao'|'medicao'|'saldo'|'avulsa'|null;
    liberada?: boolean;
    liberada_por?: string | null;
    bm_link_hash?: string | null;
    bm_status?: 'gerado'|'assinado_cliente'|'cancelado'|null;
    bm_assinado_em?: string | null;
    bm_assinado_por_nome?: string | null;
    // NF-CNAE (2026-07-27): código de serviço da NF da parcela
    cnae?: string | null;
  }>;
  // Onda Op-3a: entregáveis (serviços contratados → entrega → medição → faturamento)
  entregaveis?: Array<{
    id: string; numero_seq: number | null; descricao: string;
    valor: number | null; responsavel_email: string | null;
    status: string;
    data_prevista: string | null;
    data_entregue: string | null;
    data_medido: string | null;
    data_faturado: string | null;
    relatorio_s3_key: string | null; relatorio_nome: string | null;
    observacoes: string | null; nf_numero: string | null;
    // Onda 5: vínculos com parcelas (N:M)
    parcelas_vinculadas_count?: number;
    parcelas_vinculadas_valor?: number;
  }>;
  entregaveis_total?: number;
  entregaveis_pendentes?: number;
  entregaveis_valor_entregue?: number;
  // Briefing técnico
  setor?: string;
  tags?: string[];
  objetivos?: string;
  requisitos_especificos?: string;
  restricoes_tecnicas?: string;
  dependencias_terceiros?: string;
  cronograma_texto?: string;
  entregas_texto?: string;
  follow_up?: string;
  prazo_final?: string;
  entrega_prevista?: string;
  ultima_atualizacao_em?: string;
  equipamentos?: string[];
  equipe_emails?: string[];
  equipe_complementar?: string[];
  contato_ref_2_nome?: string;
  contato_ref_2_email?: string;
  contato_ref_2_celular?: string;
  // Atestado
  atestado_cliente_assinou_contrato?: boolean;
  atestado_cliente_assinou_art?: boolean;
  atestado_contrato_assinado?: boolean;
  atestado_art_assinada?: boolean;
  andamento_atestado?: string;
  arquivos_notion_urls?: Array<{ nome?: string; url: string }>;
  notion_page_id?: string | null;
}

// ART completa — espelha o formulário do CREA-RS (Onda 4)
export interface ArtAtividadeLinha {
  id?: number;
  cat_tecnica_id: number | null;
  cat_tecnica_nome?: string | null;
  cat_especifica_id: number | null;
  cat_especifica_nome?: string | null;
  quantidade: number | string;
  unidade: string;
  descricao_complementar: string | null;
  ordem?: number;
}
export interface ArtFull {
  id: string;
  numero: string | null;
  // Cabeçalho fiscal (passo 1 CREA-RS)
  tipo_art: string | null;
  convenio: string | null;
  participacao_tecnica: string | null;
  motivo_art: string | null;
  entidade_classe: string | null;
  empresa_executante_nome: string | null;
  empresa_executante_nr_reg: string | null;
  // RT
  rt_email: string | null; rt_nome: string | null;
  rt_carteira: string | null; rt_rnp: string | null;
  rt_titulo_profissional: string | null;
  // Vínculos
  proprietario_cliente_id: number | null; contratante_cliente_id: number | null;
  proprietario_nome: string | null; contratante_nome: string | null;
  inicio_art: string | null; fim_art: string | null;
  // Contratante estruturado
  contratante_eh_orgao_publico: boolean | null;
  contratante_cep: string | null;
  contratante_logradouro: string | null;
  contratante_numero: string | null;
  contratante_complemento: string | null;
  contratante_bairro: string | null;
  contratante_municipio: string | null;
  contratante_uf: string | null;
  contratante_telefone: string | null;
  // Obra estruturada
  obra_cep: string | null;
  obra_tipo_logradouro: string | null;
  obra_logradouro: string | null;
  obra_numero: string | null;
  obra_complemento: string | null;
  obra_bairro: string | null;
  obra_municipio: string | null;
  obra_uf: string | null;
  // Texto livre
  endereco_obra: string | null;
  resumo_contrato: string | null;
  observacao: string | null;
  // Valores
  finalidade: string | null;
  valor: number | null;
  honorarios: number | null;
  // Status CREA
  status_crea: string | null;
  assinado_govbr: boolean | null;
  data_registro_crea: string | null;
  data_pagamento_crea: string | null;
  // Anexos
  rascunho_s3_keys: string[] | null;
  assinada_s3_keys: string[] | null;
  rascunho_notion_urls?: Array<{ nome?: string; url: string }> | null;
  assinada_notion_urls?: Array<{ nome?: string; url: string }> | null;
  criado_em: string;
  // Atividades legacy (Notion — N:M soltas)
  cat_tecnicas: Array<{ id: number; nome: string }>;
  cat_especificas: Array<{ id: number; nome: string }>;
  // Atividades estruturadas (linhas CREA-RS)
  atividades_linhas: ArtAtividadeLinha[];
}

export interface Atividade {
  id: string;
  contrato_id: string;
  titulo: string;
  descricao?: string;
  tipo?: string;
  status: string;
  prioridade: string;
  data_inicio_prevista?: string;
  data_termino_previsto?: string;
  data_inicio_real?: string;
  data_termino_real?: string;
  duracao_dias?: number;
  predecessoras?: string[];
  progresso_pct: number;
  observacoes?: string;
  atribuicoes: { email: string; papel: string }[];
  criado_em: string;
  atualizado_em: string;
  criado_por?: string;
}

// KPIs do dashboard de projetos — bucket de IDs por categoria
export type KpiBucket = 'atrasados' | 'vencendo' | 'sem_responsavel'
               | 'em_execucao' | 'aguardando_faturamento' | 'sem_art';
export interface DashboardProjetos {
  atrasados: { count: number; ids: string[] };
  vencendo: { count: number; ids: string[] };
  sem_responsavel: { count: number; ids: string[] };
  em_execucao: { count: number; ids: string[] };
  aguardando_faturamento: { count: number; ids: string[] };
  sem_art: { count: number; ids: string[] };
}

export type CampoOrd = 'numero'|'titulo'|'cliente'|'gestor'|'coord'|'status'|'valor'|'atividades'|'conclusao'|'prazo_dias';

export type AbaContrato = 'visao' | 'plano' | 'briefing' | 'entregaveis' | 'atividades' | 'arts' | 'aditivos' | 'financeiro_resumo' | 'resultado' | 'atestados' | 'timeline' | 'drive' | 'mapa' | 'diarios' | 'dados_campo' | 'equipe' | 'edit';

export type ModoEtapaPlano = 'humana' | 'assistida' | 'ferramenta_pendente';
export type StatusPlanoTrabalho = 'rascunho' | 'aprovado' | 'substituido';

export interface EtapaPlanoTrabalho {
  id: string;
  titulo: string;
  descricao: string;
  modo: ModoEtapaPlano;
  responsavel_id: string | null;
  data_inicio: string | null;
  data_fim: string | null;
  entradas: string;
  resultado_esperado: string;
  criterio_aceite: string;
  dependencias: string[];
  atividade_id: string | null;
}

export interface PlanoTrabalho {
  id: string;
  versao: number;
  revisao: number;
  status: StatusPlanoTrabalho;
  objetivo: string;
  fonte: {
    objetivos: string;
    requisitos_especificos: string;
    restricoes_tecnicas: string;
    dependencias_terceiros: string;
    cronograma_texto: string;
    entregas_texto: string;
  };
  etapas: EtapaPlanoTrabalho[];
  aprovacoes: Array<{
    papel: string;
    ator_nome: string;
    ator_email: string;
    ator_id: string;
    aprovado_em: string;
  }>;
  criado_em: string;
  atualizado_em: string;
}

export interface PlanoTrabalhoSnapshot {
  permissoes: { ver: boolean; editar: boolean; aprovar: boolean; gerir_todos: boolean };
  papeis_aprovacao: Array<'gestor' | 'coordenador'>;
  aprovadores?: { gestor: string | null; coordenador: string | null };
  plano: PlanoTrabalho | null;
  plano_vigente: PlanoTrabalho | null;
  historico?: Array<{
    id: string;
    versao: number;
    status: StatusPlanoTrabalho;
    aprovacoes: PlanoTrabalho['aprovacoes'];
  }>;
  usuarios: Array<{ id: string; email: string; nome: string }>;
  atividades: Array<{
    id: string;
    titulo: string;
    status: string;
    progresso_pct: number;
    data_inicio_prevista: string | null;
    data_termino_previsto: string | null;
    predecessoras?: string[];
    atribuicoes: Array<{ email: string; papel: string }>;
  }>;
}

export type StatusArtVigencia = 'sem_dados' | 'futura' | 'vigente' | 'vencida';

// Drive
export interface DriveFolder {
  id: string; contrato_id: string; parent_id: string | null;
  nome: string; tipo: string; ordem: number;
  criado_em: string; criado_por: string;
}
export interface DriveFile {
  id: string; folder_id: string | null; pasta: string | null;
  nome: string; s3_key: string; tipo_arquivo: string | null;
  tamanho_bytes: number | null;
  versao: number; revisao_pai_id: string | null;
  vigente: boolean; visivel_para_cliente: boolean;
  descricao: string | null;
  origem: string | null; origem_ref_id: string | null;
  /** Só para origem='venda_documento': existe PDF assinado na D4 Sign para
   *  a venda deste contrato. Vem do servidor (JOIN em assinatura.envelopes) —
   *  o nome do arquivo é o mesmo nas duas vias, e o prefixo da chave deixou
   *  de distinguir quando o cache do gerado saiu de cena. */
  assinado?: boolean;
  criado_em: string; criado_por: string;
}

// Cache de usuários do grupo operacional (consumido por dropdowns/multi-select de email).
export interface UsuarioOp {
  email: string; nome: string;
  crea?: string; crea_rnp?: string; crea_titulo?: string;
}

export interface ClienteSlim { id: number; razao_social: string; cnpj: string | null; nome_fantasia: string | null; tipo_cadastro?: string; }

// Contato associado a UM cliente — vem do GET /comercial/clientes/{id}/contatos.
// Reflete o JOIN comercial.cliente_contato + comercial.contatos.
export interface ContatoClienteSlim {
  id: number;
  nome: string;
  email?: string | null;
  telefone?: string | null;
  cargo?: string | null;
  decisor?: boolean;
  principal?: boolean;  // principal NESTA empresa
}

export interface CatAtividadeSlim { id: number; nome: string; }

export interface OpcoesArt {
  tipos_art: string[];
  convenios: string[];
  participacoes_tecnicas: string[];
  motivos: string[];
  finalidades: string[];
  status_crea: Array<{ codigo: string; label: string }>;
  empresa_principal: { nome: string; nr_reg: string | null } | null;
}

// Recursos para atividades (alocação) — modelagem do backend dre.
export interface AlocacaoAtividade {
  id: string;
  pessoa_email: string | null;
  pessoa_externa_id: string | null;
  patrimonio_id: string | null;
  descricao_aluguel: string | null;
  data_inicio: string;
  data_fim: string;
  horas_dia: number;
  observacoes: string | null;
  pessoa_cargo?: string;
  pessoa_foto?: string;
  pessoa_externa_nome?: string;
  pessoa_externa_cargo?: string;
  pessoa_externa_expertises?: string[];
  patrimonio_descricao?: string;
  codigo_patrimonio?: string;
  patrimonio_categoria?: string;
}
export interface PessoaExterna {
  id: string; nome: string; cargo: string | null;
  capacidade_horas_semana: number; expertises: string[];
  tipo_vinculo?: string | null;
}
export interface PessoaInterna {
  email: string; cargo: string | null; foto_url: string | null;
  crea_titulo: string | null;
  expertises?: string[];
}
export interface RecursosBundle {
  pessoas: PessoaInterna[];
  pessoas_externas?: PessoaExterna[];
  patrimonios: Array<{ id: string; descricao: string; codigo_patrimonio: string | null;
    categoria: string; modelo: string | null }>;
}

// ─── Tabelas de display (constantes) ─────────────────────────────────
export const STATUS_CONTRATO: Record<string, { label: string; cor: string; bg: string }> = {
  planejamento:        { label: 'Planejamento',        cor: '#7C3AED', bg: '#F3E8FF' },
  kickoff_pendente:    { label: 'Kick-off pendente',   cor: '#B07500', bg: '#FFF8E8' },
  em_execucao:         { label: 'Em execução',         cor: '#0930D0', bg: '#EFF3FF' },
  pausado:             { label: 'Pausado',             cor: '#888',    bg: '#F2F2F4' },
  aguardando_aprovacao:{ label: 'Aguardando aprovação',cor: '#B07500', bg: '#FFF8E8' },
  concluido:           { label: 'Concluído',           cor: '#0a7f4a', bg: '#E8F5EE' },
  cancelado:           { label: 'Cancelado',           cor: '#B91626', bg: '#FDECEC' },
};

export const SETOR_COR: Record<string, { bg: string; cor: string }> = {
  'Hidrologia e Meio Ambiente':       { bg: '#E8F5EE', cor: '#0a7f4a' },
  'Topografia e Hidrometria':         { bg: '#EFF3FF', cor: '#0930D0' },
  'Barragens':                        { bg: '#FDECEC', cor: '#B91626' },
  'Projetos Civis e Saneamento':      { bg: '#FFF8E8', cor: '#B07500' },
};

export const STATUS_ATIVIDADE: Record<string, { label: string; cor: string; bg: string; ordem: number }> = {
  pendente:     { label: 'Pendente',      cor: '#666',    bg: '#F2F2F4', ordem: 1 },
  em_andamento: { label: 'Em andamento',  cor: '#0930D0', bg: '#EFF3FF', ordem: 2 },
  bloqueada:    { label: 'Bloqueada',     cor: '#B91626', bg: '#FDECEC', ordem: 3 },
  concluida:    { label: 'Concluída',     cor: '#0a7f4a', bg: '#E8F5EE', ordem: 4 },
  cancelada:    { label: 'Cancelada',     cor: '#888',    bg: '#F2F2F4', ordem: 5 },
};

export const PRIORIDADE_ATIVIDADE: Record<string, { label: string; cor: string; emoji: string }> = {
  alta:  { label: 'Alta',  cor: '#B91626', emoji: '🔴' },
  media: { label: 'Média', cor: '#B07500', emoji: '🟡' },
  baixa: { label: 'Baixa', cor: '#0a7f4a', emoji: '🟢' },
};

export const TIPO_ATIVIDADE: Record<string, { label: string; emoji: string }> = {
  kickoff_interno:   { label: 'Kick-off interno',   emoji: '🎯' },
  kickoff_externo:   { label: 'Kick-off com cliente', emoji: '🤝' },
  campo:             { label: 'Campo',              emoji: '🌳' },
  processamento:     { label: 'Processamento',      emoji: '⚙️' },
  entrega:           { label: 'Entrega',            emoji: '📦' },
  reuniao:           { label: 'Reunião',            emoji: '💬' },
  aprovacao_cliente: { label: 'Aprovação cliente',  emoji: '✅' },
  art:               { label: 'ART',                emoji: '📋' },
  tarefa:            { label: 'Tarefa',             emoji: '📝' },
  marco:             { label: 'Marco',              emoji: '⭐' },
};

export const KPI_CARDS: Array<{ key: KpiBucket; label: string; emoji: string;
  cor: string; bg: string; descr: string }> = [
  { key: 'atrasados',              label: 'Atrasados',          emoji: '🚨',
    cor: '#B91626', bg: '#FDECEC',
    descr: 'Prazo de entrega passou e contrato não está concluído' },
  { key: 'vencendo',               label: 'Vencendo em 7d',     emoji: '⏰',
    cor: '#B07500', bg: '#FFF8E8',
    descr: 'Prazo de entrega entre hoje e os próximos 7 dias' },
  { key: 'sem_responsavel',        label: 'Sem gestor',         emoji: '🟡',
    cor: '#7C3AED', bg: '#F3E8FF',
    descr: 'Contrato sem gestor designado' },
  // 'Em execução' e 'Saldo a faturar' saíram da fileira (2026-06-19): o
  // primeiro é estado normal (não alerta); o segundo é financeiro (vive em
  // Contas a Receber). Sobram só os alertas operacionais. Os buckets seguem
  // no tipo/dashboard caso voltem como card no futuro.
  { key: 'sem_art',                label: 'ART pendente',       emoji: '📋',
    cor: '#444',    bg: '#F2F2F4',
    descr: 'Contrato em execução sem ART vigente' },
];

export const DRIVE_TIPO_ICONE: Record<string, string> = {
  comercial: '📋', arts: '🪪', relatorios: '📄',
  pecas_graficas: '🎨', upload_cliente: '📥', usuario: '📁',
};

// Status do registro da ART no CREA — espelha o que aparece na lista do portal.
// Distinto do status visual baseado em vigência (statusArtVigencia em utils).
export const STATUS_CREA_VIS: Record<string, { label: string; cor: string; bg: string }> = {
  rascunho_interno: { label: 'Rascunho',     cor: '#666',    bg: '#F2F2F4' },
  preenchida:       { label: 'Preenchida',   cor: '#0930D0', bg: '#EFF3FF' },
  registrada:       { label: 'Registrada',   cor: '#0a7f4a', bg: '#E8F5EE' },
  paga:             { label: 'Paga',         cor: '#0a7f4a', bg: '#D0EDDB' },
  cancelada:        { label: 'Cancelada',    cor: '#B91626', bg: '#FDECEC' },
  // KICKOFF (2026-08-20): saída para o contrato que não exige ART. Todo
  // contrato passa a nascer com um rascunho, e sem essa saída a cobrança
  // semanal ficaria perseguindo contrato que nunca vai ter ART.
  dispensada:       { label: 'Não se aplica', cor: '#888',  bg: '#F2F2F4' },
};

export const VIGENCIA_VIS: Record<StatusArtVigencia, { label: string; cor: string }> = {
  sem_dados: { label: 'Sem datas',  cor: '#aaa' },
  futura:    { label: 'Futura',     cor: '#7C3AED' },
  vigente:   { label: 'Em vigência',cor: '#0a7f4a' },
  vencida:   { label: 'Vencida',    cor: '#B91626' },
};
